import {useStyles} from '@wix/tpa-settings/react'
import {MOBILE_WIDGET_LAYOUT} from '@wix/wix-events-commons-statics'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {isMobile} from '../../../../../../../commons/selectors/environment'
import stylesParams from '../../../../../stylesParams'
import {useWidgetState} from '../../../../hooks/state-provider'
import {useEventsList} from '../../../../hooks/use-events-list'
import {getComponentConfig} from '../../../../selectors/settings'
import {focusFirstNewEvent} from '../../../../utils/a11y'
import {CategoryTabs} from '../../../category-tabs'
import {EmptyCategory} from '../../../category-tabs/empty-category'
import {CardContainer} from '../../../event-container/card-container'
import {ListItemContainer} from '../../../event-container/list-item-container'
import {LoadMoreButton} from '../../../load-more-button'
import {MainListTitle} from '../../../main-list-title'
import {CardsMobileItem} from '../cards-mobile-item'
import s from './mobile-cards-list.scss'

export const MobileCardsList = () => {
  const {events, hasMore, moreLoading, pageLimit} = useEventsList()
  const {get} = useStyles()

  const mobile = useWidgetState(isMobile)
  const componentConfig = useWidgetState(getComponentConfig)

  const className = classNames(s.container, {[s.narrow]: !mobile})

  const Container =
    get(stylesParams.mobileWidgetLayoutNew) !== MOBILE_WIDGET_LAYOUT.GRID ? ListItemContainer : CardContainer

  const eventsCount = events.length

  useEffect(() => {
    focusFirstNewEvent({eventsCount, pageLimit, hasMore, compId: componentConfig.id})
  }, [eventsCount])

  return (
    <div className={className} data-hook="ev-list-layout">
      <MainListTitle />
      <CategoryTabs />
      {!events.length ? (
        <EmptyCategory />
      ) : (
        <>
          <ul>
            {events.map((event: ExtendedEvent, index: number) => (
              <Container
                mobile
                key={event.id}
                event={event}
                showTopDivider={index === 0}
                lastItem={events.length - 1 === index}
              >
                {hovered => <CardsMobileItem event={event} hovered={hovered} />}
              </Container>
            ))}
          </ul>
          <LoadMoreButton mobile hasMore={hasMore} moreLoading={moreLoading} />
        </>
      )}
    </div>
  )
}
